'use strict';

var _stages = require('./stages');

var _tasks = require('./tasks');

var _jobs = require('./jobs');

var _helper = require('./helper');

// import icons from './icons';
module.exports = {
  isStageComplete: _stages.isStageComplete,
  isTaskComplete: _stages.isTaskComplete,
  getCurrentStage: _stages.getCurrentStage,
  isFirstStage: _stages.isFirstStage,
  generateItems: _tasks.generateItems,
  getLastAck: _tasks.getLastAck,
  calculateResourceSummary: _jobs.calculateResourceSummary,
  toArray: _helper.toArray
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sakari-io/staza-common/dist/index.js
// module id = 353
// module chunks = 0